"use strict";

// CommonJS requires guarantee execution order.
// window.jQuery MUST be set before Kendo loads or it won't attach to the global $.
require('jquery/dist/jquery');
require('webpack-jquery-ui/css');

const $ = require('jquery');
window.jQuery = $;
window.$ = $;

require('@progress/kendo-ui');
require('@progress/kendo-ui/js/kendo.aspnetmvc');
require('@progress/kendo-ui/js/kendo.all.js');

require('sortablejs/modular/sortable.core.esm.js');
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap/dist/js/bootstrap');

require('jquery-validation/dist/jquery.validate');
require('jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive');

require('popper.js/dist/umd/popper');
require('bootstrap/js/dist/util');
require('bootstrap/js/dist/tooltip');
require('lodash/lodash');